var exports = {
  "w": "xfd349460--f32b43--header",
};

module.exports = exports;
